<template>
    <div class="inner-wrapper">
        <div class="page-title quote-title">
            <h1 class="float-left"><router-link :to="{name: 'viewQuote', params:{id: $route.params.id}}"><i class="fa fa-arrow-left"></i></router-link> Quote to Customer</h1>
            <div class="title-right float-right">

            </div>
        </div>
        <div class="new-rfq">
            <div class="alert alert-success" role="alert" v-if="successMessage">
                {{successMessage}}
            </div>

            <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                        <p v-for="error in v" :key="error" class="text-sm">
                            {{ error }}
                        </p>
                    </li>
                </ul>
            </div>

            <div class="row">
                <div class="col-xs-12 col-sm-7 col-md-8 col-lg-8">
                    <img style="width:130px;" :src="asset('/admin/images/logo.png')" alt="logo"/>
                    <div class="addrss-left" v-if="meta_setting">
                        <span>{{ meta_setting.address_1 }}</span><br/>
                        <span>{{ meta_setting.address_2 }}</span><br/>
                        <span>Tel. <b>{{ meta_setting.phone }}</b> </span> <br/>
                        <span>Fax. <b>{{ meta_setting.fax }}</b> </span>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-5 col-md-4 col-lg-4" v-if="customer_contact">
                    <div class="addrss-rght">
                        <h5>Quotation to</h5>
                        <span>
                            <template v-if="customer_contact.contact_name != ''">
                                {{ customer_contact.contact_name }} ({{ customer_detail.company_name }})
                            </template>
                            <template v-else>
                                {{ customer_detail.company_name }}
                            </template>
                        </span> <br/>
                        <span>{{ customer_contact.email }}</span><br/>
                        <span>Tel. <b v-if="customer_number"> {{ customer_number.contact_no }}</b></span> <br/>
                        <span>{{ customer_detail.address }}</span>
                    </div>
                </div>
            </div>
            <hr />

            <div class="custom-row" v-if="quotation != null && quote_detail != null">
                <div class="customer-box shadow-sm p-3">
                    <div class="row">
                        <div id="error_alert" class="alert alert-success" style="display: none;">
                            <strong>Please fill out * fields</strong>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <div class="form-group">
                                <label for="quotation_number" class="control-label">Quote Number</label>
                                <input type="text" id="quotation_number" class="input_text has-value form-control"
                                    :value="'#'+quotation.quotation_number" readonly="readonly"/>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <div class="form-group">
                                <label for="terms" class="control-label">Terms</label>
                                <input type="text" class="input_text has-value form-control" name="terms" id="terms"
                                    v-model="quote_detail.terms" readonly="readonly"/>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <div class="form-group">
                                <label for="sale_rep_name" class="control-label">Sales REP</label>
                                <input type="text" id="sale_rep_name" class="input_text has-value form-control"
                                    v-model="sale_rep_name" readonly=""/>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <div class="form-group">
                                <label for="valid_date" class="control-label">Lead Time</label>
                                <input type="text" class="input_text has-value form-control" name="valid_date" id="valid_date"
                                    v-model="quote_detail.valid_date" readonly="readonly" />
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <div class="form-group">
                                <label for="ship_via" class="control-label">Ship Via</label>
                                <input type="text" class="input_text has-value form-control" name="ship_via" id="ship_via"
                                    v-model="quote_detail.ship_via" readonly="readonly" />
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <div class="form-group">
                                <label for="fob" class="control-label">FOB</label>
                                <input type="text" class="input_text has-value form-control" name="fob" id="fob"
                                    v-model="quote_detail.fob" readonly="readonly"/>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <div class="form-group cylinder_amt">
                                <label for="cylinder_amt" class="control-label">Total Cylinders</label>
                                <input type="text" class="input_text has-value format_number form-control" name="cylinder_amt"
                                    id="cylinder_amt" v-model="quotation.cylinder_amt" readonly="readonly"/>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <div class="form-group cylinder_cost">
                                <label for="cylinder_cost" class="control-label">Price per Cylinder</label>
                                <input type="text" class="input_text has-value form-control" name="cylinder_cost"
                                    id="cylinder_cost"
                                    v-model="quotation.cylinder_cost"  readonly="readonly"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="customer-box shadow-sm p-3">
                    <div class="row">
                        <div class="col-md-12 white-bg2 pd-btm-0">
                            <h4>Product</h4>
                            <div class="table-responsive product-create">
                                <template v-for="(product, index) in quote_products">
                                    <table class="table table-hover table-custom">
                                        <tr class="tbl-blue">
                                            <td colspan="5">
                                                {{product.product_name}}
                                                <span class="pull-right pr-nmbr">Tiers/Product <span>{{product.count_tiers}}</span></span>
                                            </td>
                                        </tr>
                                        <tr class="grey-heading">
                                            <th>Item</th>
                                            <th>Description</th>
                                            <th>qty</th>
                                            <th>price</th>
                                            <th>Total</th>
                                        </tr>
                                        <tr>
                                            <td :rowspan="product.count_tiers">{{product.product_name}}</td>
                                            <td width="40%" :rowspan="product.count_tiers">{{product.description}}</td>
                                            <template v-if="product.primary_tiers.length">
                                                <td>{{product.primary_tiers.tier_value}}</td>
                                                <td>{{product.primary_tiers.selling}}</td>
                                                <td>{{product.primary_tiers.total_amt}}</td>
                                            </template>
                                        </tr>
                                        <template v-if="product.rest_tiers.length">
                                            <template v-for="(tier, tierIndex) in product.rest_tiers">
                                                <tr>
                                                    <td>{{tier.tier_value}}</td>
                                                    <td>{{tier.selling}}</td>
                                                    <td>{{tier.total_amt}}</td>
                                                </tr>
                                            </template>
                                        </template>
                                    </table>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="customer-box shadow-sm p-3">
                    <div class="pd-btm-0">
                        <h4>Terms & Condition </h4>
                        <hr/>
                        <ckeditor v-model="quote_detail.terms"
                                  tag-name="textarea"
                                  :config="{}"></ckeditor>
                    </div>
                </div>
                <div class="btnrow text-right">
                    <div class="white-bg3">
                        <button class="btn btn-blue pull-left skip-btn" type="button" @click="download">Download PDF</button>
                    </div>
                </div>
            </div>

        </div>

        <footer class="footer">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-6">
                                2022 © Superb.
                            </div>
                            <div class="col-sm-6">
                                <div class="text-right d-none d-sm-block">
                                    All Rights Reserved.
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import axios from "axios";

export default {
    name: "QuoteSentCustomer",
    created() {
        this.getSendToCustomerPageData();
    },
    mounted() {

    },
    data() {
        return {
            id: null,
            smtp_user: null,
            quotation: null,
            sale_rep_name: null,
            customer_contact: null,
            quote_products: [],
            customer_number: null,
            quote_detail: null,
            customer_detail: null,
            meta_setting: null,
            user: null,
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        getSendToCustomerPageData() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('ViewCustomerQuote', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.smtp_user = data.data.smtp_user;
                        this.quotation = data.data.quotation;
                        this.sale_rep_name = data.data.sale_rep_name;
                        this.customer_contact = data.data.customer_contact;
                        this.quote_products = data.data.quote_products;
                        this.customer_number = data.data.customer_number;
                        this.quote_detail = data.data.quote_detail;
                        this.customer_detail = data.data.customer_detail;
                        this.meta_setting = data.data.meta_setting;
                        this.user = data.data.user;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        download(d) {
            let url = window.route('DownloadQuotePdf', {
                id: this.quotation.id
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", url);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
    },
    computed: {
        ...mapState([
            'userState',
            'quotationState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading'
        ])
    },
    watch: {

    }
}
</script>

<style scoped>

</style>
